import { CheckCircle, HourglassTop } from "@mui/icons-material";
import {
  KODE_STATUS_TYPE,
  STATUS_TYPE,
} from "../constants/StatusType.constants";
import { SIDANG_TYPE_WITH_JENJANG } from "../constants/SidangType.constants";
import PlaceDateTime from "../../components/common/PlaceDateTime/PlaceDateTime";

function createColumnsMaterialTable(sekreRole = false) {
  const columns = [
    {
      title: "Jenis MK Spesial",
      field: "jenis_mk_spesial",
      lookup: SIDANG_TYPE_WITH_JENJANG,
    },

    { title: "Judul", field: "judul" },

    {
      title: "Mahasiswa",
      field: "anggota",
      grouping: false,
      render: (rowData) => (
        <ul className="ml-4 list-disc">
          {rowData.anggota.map((mahasiswa, index) => (
            <li key={index}>{mahasiswa.nama_mahasiswa}</li>
          ))}
        </ul>
      ),
      customFilterAndSearch: (filter, rowData) =>
        rowData.anggota.some((mahasiswa) => {
          let mahasiswaName = mahasiswa.nama_mahasiswa.toLowerCase();
          let filterLowered = filter.toLowerCase();
          return mahasiswaName.includes(filterLowered);
        }),
    },

    {
      title: "Dosen",
      grouping: false,
      hidden: sekreRole ? false : true,
      render: (rowData) => (
        <div>
          <b>Pembimbing</b>
          {rowData.pembimbing.length === 0 ? (
            <p>-</p>
          ) : (
            <ul className="ml-4 list-disc">
              {rowData.pembimbing.map((dosbing, index) => (
                <li key={index}>{dosbing}</li>
              ))}
            </ul>
          )}

          <b>Penguji</b>
          {rowData.penguji.length === 0 ? (
            <p>-</p>
          ) : (
            <ul className="ml-4 list-disc">
              {rowData.penguji.map((dosji, index) => (
                <li key={index}>{dosji}</li>
              ))}
            </ul>
          )}
        </div>
      ),
      customFilterAndSearch: (filter, rowData) => {
        const filterLowered = filter.toLowerCase();
        return (
          rowData.pembimbing.some((dosbing) =>
            dosbing.toLowerCase().includes(filterLowered)
          ) ||
          rowData.penguji.some((dosji) =>
            dosji.toLowerCase().includes(filterLowered)
          )
        );
      },
    },

    {
      title: "Status",
      field: "kode_status",
      lookup: STATUS_TYPE,
      grouping: false,
      render: (rowData) => (
        <div>
          {rowData.kode_status === KODE_STATUS_TYPE.SELESAI_MK_SPESIAL ? (
            //Jika status == selesai MK spesial
            <CheckCircle className="text-green-500" />
          ) : (
            <HourglassTop className="text-orange-400" />
          )}
          {rowData.pesan_status}
        </div>
      ),
    },

    {
      title: "Keterangan",
      filtering: false,
      grouping: false,
      defaultSort: "asc",
      render: (rowData) => {
        if (rowData.keterangan.tanggal) {
          return (
            <div>
              <b>
                {rowData.kode_status === KODE_STATUS_TYPE.MENUNGGU_SIDANG
                  ? "Jadwal Sidang"
                  : rowData.kode_status === KODE_STATUS_TYPE.PROSES_EVALUASI
                  ? "Batas Waktu Mahasiswa Merevisi"
                  : "Batas Waktu"}
              </b>
              <PlaceDateTime
                isOldVersion={false}
                isOnline={rowData.keterangan.is_online}
                place={rowData.keterangan.lokasi}
                date={rowData.keterangan.tanggal}
                startTime={rowData.keterangan.waktu}
                endTime={rowData.keterangan.waktu_selesai}
              />
            </div>
          );
        } else if (
          rowData.kode_status === KODE_STATUS_TYPE.SELESAI_MK_SPESIAL
        ) {
          return (
            <div className="text-green-500">
              <CheckCircle />
              Selesai
            </div>
          );
        }
        return <div>---</div>;
      },
      customSort: (data1, data2) => {
        if (data1.keterangan.waktu && data2.keterangan.waktu) {
          return (
            new Date(`${data2.keterangan.tanggal}T${data2.keterangan.waktu}Z`) -
            new Date(`${data1.keterangan.tanggal}T${data1.keterangan.waktu}Z`)
          );
        } else if (data1.kode_status === KODE_STATUS_TYPE.SELESAI_MK_SPESIAL) {
          return -1;
        } else if (data1.keterangan.waktu) {
          return -1;
        }
        return 1;
      },
    },
  ];

  return columns;
}

export { createColumnsMaterialTable };
